import React, { useState, useEffect, useRef } from 'react';

interface Props {
  moveNumber: number;
  onSave: (tag: string, comment: string) => void;
  onCancel: () => void;
}

const BookmarkDialog: React.FC<Props> = ({ moveNumber, onSave, onCancel }) => {
  const [tag, setTag] = useState('');
  const [comment, setComment] = useState('');
  const tagRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    tagRef.current?.focus();
  }, []);

  const handleSave = () => {
    onSave(tag.trim(), comment.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) handleSave();
    if (e.key === 'Escape') onCancel();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onCancel}>
      <div style={{ background: '#fff', borderRadius: '10px', padding: '24px', width: '340px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontWeight: 600, fontSize: '16px', marginBottom: '4px' }}>Bookmark Position</div>
          <div style={{ fontSize: '12px', color: '#999' }}>Move {moveNumber}</div>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '4px' }}>Tag</label>
          <input
            ref={tagRef}
            value={tag}
            onChange={e => setTag(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g. Good shape, Mistake, Joseki..."
            style={{ width: '100%', padding: '7px 10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '4px' }}>Comment</label>
          <textarea
            value={comment}
            onChange={e => setComment(e.target.value)}
            onKeyDown={e => { if (e.key === 'Escape') onCancel(); }}
            placeholder="Optional notes..."
            rows={3}
            style={{ width: '100%', padding: '7px 10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical', outline: 'none' }}
          />
        </div>

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{ padding: '7px 16px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
            Cancel
          </button>
          <button onClick={handleSave} style={{ padding: '7px 16px', border: 'none', borderRadius: '6px', background: '#4a90e2', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookmarkDialog;
